<ng-template [ngIf]="quadroCompensiGrid && quadroCompensiGrid.length > 0" > 
<h5><strong>Quadro compensi</strong></h5>
<div>
	<p class="col-sm-3 singlecheckbox inlineformelem alignright">
		<label class="alignright fakelabel">Fasi</label>
		<input [checked]="fasicheckedAll" id="fasicheckadd{{quadroPreCompilato}}" type="checkbox" (change)="setFase()">
		<label for="fasicheckadd{{quadroPreCompilato}}"></label>
	</p>
	<p class="col-sm-2 singlecheckbox inlineformelem alignright radiobutton">
		<label class="alignright fakelabel">Min</label>
		<input [checked]="mincheckedAll" [disabled]="!checkAtLeastOneFase()" id="minimocheckadd" type="radio" name="fase" (change)="setMin()">
		<label for="minimocheckadd"></label>
	</p>
	<p class="col-sm-2 singlecheckbox inlineformelem alignright radiobutton">
		<label class="alignright fakelabel">Med</label>
		<input [checked]="medcheckedAll" [disabled]="!checkAtLeastOneFase()" id="mediocheckadd" type="radio" name="fase" (change)="setMed()">
		<label for="mediocheckadd"></label>
	</p>
	<p class="col-sm-2 singlecheckbox inlineformelem alignright radiobutton">
		<label class="alignright fakelabel">Max</label>
		<input [checked]="maxcheckedAll" [disabled]="!checkAtLeastOneFase()" id="massimocheckadd" type="radio" name="fase" (change)="setMax()">
		<label for="massimocheckadd"></label>
	</p>
	<p class="col-sm-3 alignright">
		<label class="fakelabel">Compenso</label>
	</p>
</div>


<ng-template ngFor let-q [ngForOf]="quadroCompensiGrid" let-iv=index> 	
<div>
	<p class="col-sm-3 singlecheckbox inlineformelem alignright">
		<label class="alignright fakelabel">{{q.fase.tipoFase.label}}</label>
		<input [checked]="q.checkedFase" id="{{q.idCheckboxFase}}" (change)="gstRadio(q.fase.id,$event.target.checked);" type="checkbox">
		<label for="{{q.idCheckboxFase}}"></label>
	</p>
	<p class="col-sm-2 singlecheckbox inlineformelem alignright radiobutton">
		<label class="alignright fakelabel">{{q.valoreMinimo | euro}} &euro;</label>
		<input [checked]="q.checkedMin" [disabled]="!q.checkedFase || q.disabledMin" name="{{q.nameRadio}}" id="{{q.idRadioMin}}" [value]="q.valoreMinimo" (click)="settaImportoFase(q.fase.id,q.valoreMinimo,0,q.checkedMin)" type="radio">
		<label for="{{q.idRadioMin}}"></label>
	</p>
	<p class="col-sm-2 singlecheckbox inlineformelem alignright radiobutton">
		<label class="alignright fakelabel">{{q.valoreMedio | euro}} &euro;</label>
		<input [checked]="q.checkedMed" [disabled]="!q.checkedFase || q.disabledMed" name="{{q.nameRadio}}" id="{{q.idRadioMed}}" [value]="q.valoreMedio" (click)="settaImportoFase(q.fase.id,q.valoreMedio,1,q.checkedMed)" type="radio">
		<label for="{{q.idRadioMed}}"></label>
	</p>
	<p class="col-sm-2 singlecheckbox inlineformelem alignright radiobutton">
		<label class="alignright fakelabel">{{q.valoreMassimo | euro}} &euro;</label>
		<input [checked]="q.checkedMax" [disabled]="!q.checkedFase || q.disabledMax" name="{{q.nameRadio}}" id="{{q.idRadioMax}}" [value]="q.valoreMassimo" (click)="settaImportoFase(q.fase.id,q.valoreMassimo,2,q.checkedMax)" type="radio">
		<label for="{{q.idRadioMax}}"></label>
	</p>
	<p class="col-sm-3" textInputCurrency [(ngModel)]="q.compenso" [submitPending]="!q.checkedFase" [location]="'SezioneQuadroPacelle'" (onReturn)="disableRadio(q)"></p>

</div>
</ng-template>
					
<div>
	<p class="col-sm-offset-7 col-sm-2 alignright">
		<label for="alignright totale">Totale</label>
	</p>
	<p class="col-sm-3 alignright">
		<input name="totale" class="totale form-control alignright" disabled="true" value="{{ricalcolaTotale()}}" type="text">
	</p>
</div>
</ng-template>